// DS1.7.21
import React from 'react';
import CoreSymbol from '../CoreSymbol';
import { IconSize } from '../../Icons/IconWrap';
import s from './CoreUpgrade.scss';
const CoreUpgrade = ({ children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(CoreSymbol, {
        size: IconSize.SMALL
    }), children);
};
CoreUpgrade.displayName = 'CoreUpgrade';
export default CoreUpgrade;
